<template>
  <div class="p-4">
    <vs-avatar
      :badge="newUpdates"
      text="Luisdaniel"
      @click="openChangelogs()"
    />
  </div>
</template>

<script setup>
import {
  openChangelogs,
  useChangelogs,
} from '@//views/experimental/changelogs/useChangelogs';

const { isNew, newUpdates } = useChangelogs();
</script>

<style lang="scss" scoped></style>
